export default {"src":"/_next/static/media/berry-street-logo-lockup-green.b1384d70.svg","height":96,"width":519,"blurWidth":0,"blurHeight":0};